import { esNativo } from '../config/entorno';

function pluginNativo() {
  const { registerPlugin } = window.Capacitor || {};
  if (typeof registerPlugin === 'function') {
    return registerPlugin('GastosAuth');
  }
  return null;
}

export async function guardarTokenNativo(token) {
  if (!esNativo()) return;
  try {
    const { registerPlugin } = await import('@capacitor/core');
    const GastosAuth = registerPlugin('GastosAuth');
    await GastosAuth.setToken({ token: token || '' });
    await GastosAuth.refreshWidget();
  } catch (err) {
    console.warn('No se pudo sincronizar el token con el widget', err);
  }
}

export function abrirRutaDesdeWidget(url, router) {
  const raw = String(url || '');
  if (!raw) return false;
  if (raw.startsWith('gastosapp://tp') || raw.includes('/salud-trainingpeaks')) {
    if (router && typeof router.push === 'function') {
      router.push('/salud-trainingpeaks');
    }
    return true;
  }
  return false;
}

export { pluginNativo };
